module.exports = __webpack_public_path__ + "static/media/irancell.09e1f63d.svg";